import { Box } from "@chakra-ui/react";
import React, { Fragment, useEffect } from "react";
import GameTypeSelector from "../../components/v2Layout/GameTypeSelector/GameTypeSelector";
import SubListSelector from "../../components/v2Layout/SubListSelector/SubListSelector";
import JackpotWrapper from "../../components/v2Layout/Jackpot/JackpotWrapper";
import PlatformSelector from "../../components/v2Layout/PlatformSelector/PlatformSelector";
import GameSelector from "../../components/v2Layout/GameSelector/GameSelector";
import MobileSearchV2 from "../Search/mobile-search_v2";
import MarqueeListV2 from "../../components/marquee/marqueeList_v2";
import CarouselV2 from "../../components/Carousel_v2";
import { useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { routeMapping } from "../../components/v2Layout/GameTypeSelector/utils/routeMapping";
import LeaderBoard from "../../components/v2Layout/LeaderBoard/LeaderBoard";
import GameCatalogV2 from "../../components/GameCatalog_v2";
import ExceptWrapper from "./utils/exceptWrapper";

const GamePlatformPageV2 = () => {
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { gameType, topGameList, newGameList } = isHandleAllGame;

  const { gameMainType } = useParams();

  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (gameMainType) {
  //     const current_type = routeMapping(gameMainType)?.origin;
  //     if (!gameType?.includes(current_type)) {
  //       return navigate("/slots");
  //     }
  //   }
  // }, [gameType, gameMainType]);
  return (
    <Fragment>
      <ExceptWrapper
        exceptGameType={[
          "live-casino",
          "sports",
          "lottery",
          "fish",
          "arcade",
          "block-chain",
          "table",
        ]}
      >
        <Box as="section" py="home-space" px="common-y">
          <CarouselV2 />
        </Box>
      </ExceptWrapper>
      <ExceptWrapper
        exceptGameType={[
          "live-casino",
          "sports",
          "lottery",
          "fish",
          "arcade",
          "block-chain",
          "table",
        ]}
      >
        <Box as="section" pb={{ md: "0", base: "home-space" }} px="common-y">
          <MarqueeListV2 />
        </Box>
      </ExceptWrapper>
      <Box
        py={{
          md: "home-space",
          base: "0",
        }}
        px="common-y"
      >
        <GameTypeSelector />
      </Box>
      <Box
        mt={{
          md: "0px",
          base: "10px",
        }}
      >
        <MobileSearchV2 listHidden />
      </Box>
      <Box pb="home-space" px="common-y">
        <PlatformSelector />
      </Box>

      {/* <Box py="home-space" px="common-y">
        <LeaderBoard />
      </Box>
       <Box mt="home-space" px="common-y">
        <JackpotWrapper />
      </Box> */}
      {/* <ExceptWrapper
        exceptGameType={[
          "live-casino",
          "sports",
          "lottery",
          "fish",
          "arcade",
          "block-chain",
          "table",
        ]}
      >
        <Box px="common-y">
          <GameCatalogV2
            wrapperClassName={`!px-[0px]`}
            list={topGameList}
            mainTitle={`Top`}
            // swiperProps={{
            //   customPerView: "popular-layout",
            // }}
            isHot
            customFixedWidth="160px"
          />
        </Box>{" "}
      </ExceptWrapper> */}

      {/* <ExceptWrapper
        exceptGameType={[
          "live-casino",
          "sports",
          "lottery",
          "fish",
          "arcade",
          "block-chain",
          "table",
        ]}
      >
        <Box px="common-y">
          <GameCatalogV2
            wrapperClassName={`!px-[0px]`}
            list={newGameList}
            mainTitle={`News`}
            // swiperProps={{
            //   customPerView: "popular-layout",
            // }}
            isHot
            customFixedWidth="160px"
          />
        </Box>
      </ExceptWrapper> */}

      <Box py="home-space" px="common-y">
        {/* <SubListSelector /> */}
        <GameSelector subListSelector />
      </Box>
    </Fragment>
  );
};

export default GamePlatformPageV2;
